<template>
    <b-modal
        id="group-pair-add-teacher-modal"
        v-model="modal"
        :title="$t('group_pair.add_teachers')"
        :ok-title="$t('common.save')"
        ok-only
        cancel-disabled
        dialog-class="assignment-modal"
        modal-class="apprentice-default-modal"
        size="lg"
        @show="onShow"
        @ok="onOk">
        <b-alert
            show
            variant="warning">
            {{ $t('group_pair.max_amount_of_groups_cannot_be_empty') }}
        </b-alert>

        <design-2021-apprentice-data-table
            :items="teachers"
            :fields="fields"
            :filter-function="customFilter">
            <template v-slot:cell(name)="data">
                <div class="name">
                    {{ data.item.full_name }}
                </div>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <design-2021-group-pair-index-add-teacher-add-input-modal
                        :user="data.item"
                        :key="data.item.id"
                        @change="userValuesChanged($event)"
                        :ref="
                            'teacher-input-' + data.item.id
                        "></design-2021-group-pair-index-add-teacher-add-input-modal>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-group-pair-index-add-teacher-modal',
    props: ['groupIdIn'],
    data() {
        return {
            modal: false,
            loaded: false,
            teachers: [],
            changed_values: [],
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.add'),
                },
            ],
        };
    },
    methods: {
        userValuesChanged(data) {
            let check = this.changed_values.some((value) => value.user_id === data.user_id);

            if (!check) {
                this.changed_values.push(data);
                return;
            }

            this.changed_values = this.changed_values.map((values) => {
                return values.user_id === data.user_id ? data : values;
            });
        },

        onOk(bvModalEvt) {
            bvModalEvt.preventDefault();

            let alert = false;

            let teachers = [];

            teacherLoop: for (const teacher of this.teachers) {
                for (const values of this.changed_values) {
                    if (teacher.id === values.user_id) {
                        teachers.push(values);
                        continue teacherLoop;
                    }
                }

                teachers.push({
                    user_id: teacher.id,
                    max: teacher.group_pair_teachers.length ? teacher.group_pair_teachers[0].max : null,
                    selected: teacher.group_pair_teachers.length,
                });
            }

            if (alert === true) {
                this.alert
                    .confirm(
                        this.$t('group_pair.disconnect_teachers'),
                        this.$y(
                            'group_pair.one_or_more_teachers_are_chosen_by_a_group_are_you_sure_you_want_to_disconnect_this',
                        ),
                        this.$t('group_pair.yes_disconnect'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.updateTeacher(teachers);
                        }
                    });
            } else {
                this.updateTeacher(teachers);
            }

            // this.$emit('add-teachers', this.teachers);
        },

        resetForms() {
            const self = this;
            Vue.nextTick().then(function () {
                for (const teacher of self.teachers) {
                    const ref = 'teacher-input-' + teacher.id;
                    if (self.$refs[ref]) {
                        self.$refs[ref].reset();
                    }
                }
            });
        },

        updateTeacher(teachers) {
            this.alert.saving();

            const data = { teachers: teachers };

            this.axios.post(this.routes.groupPairTeachersUpdate(this.groupIdIn), data).then(
                (response) => {
                    ords.hold();

                    teacherLoop: for (const teacher of this.teachers) {
                        for (const requestTeacher of response.data) {
                            if (requestTeacher.user_id === teacher.id) {
                                if (!teacher.group_pair_teachers.length) {
                                    teacher.addRelation('group_pair_teachers', requestTeacher);
                                } else {
                                    if (teacher.group_pair_teachers[0].max !== requestTeacher.max) {
                                        teacher.group_pair_teachers[0].update(requestTeacher);
                                    }
                                }

                                continue teacherLoop;
                            }
                        }

                        if (teacher.group_pair_teachers.length) {
                            teacher.group_pair_teachers[0].remove();
                        }
                    }

                    ords.continue();

                    this.alert.success();
                    this.modal = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            if (!this.loaded) {
                this.alert.loading();

                this.axios.get(this.routes.groupPairTeachersGet(this.groupIdIn)).then(
                    (response) => {
                        ords.use('user').add(response.data);

                        ords.use('user')
                            .where('type', '=', 'teacher')
                            .with('group_pair_teachers')
                            .with('group_pair_group_teachers', (groupPairGroupTeachersCallback) => {
                                groupPairGroupTeachersCallback.whereHas('group_pair_groups');
                            })
                            .get()
                            .subscribe((teachers) => (this.teachers = teachers));

                        this.loaded = true;

                        this.alert.loaded();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.changed_values = [];
                this.resetForms();
            }
        },

        customFilter(row, filter) {
            const name = this.$options.filters.normalize_string(row.name);
            const surname = this.$options.filters.normalize_string(row.surname);
            const email = this.$options.filters.normalize_string(row.email);
            const cleanFilter = this.$options.filters.normalize_string(filter);

            if (
                name.indexOf(cleanFilter) !== -1 ||
                surname.indexOf(cleanFilter) !== -1 ||
                email.indexOf(cleanFilter) !== -1
            ) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style scoped></style>
